<script>
  import { onMount } from "svelte";

  export let enabled;
  export let backgroundColor;

  let node;

  function hideElement() {
    if (node && node.parentElement) {
      node.parentElement.style.display = "none";
    }
  }

  $: if (!enabled) {
    hideElement();
  }

  onMount(() => {
    if (!enabled) {
      hideElement();
    }

    if (backgroundColor) {
      node.style.backgroundColor = backgroundColor;
    }
  });
</script>

<div
  bind:this={node}
  class="tw-flex tw-items-center tw-justify-center tw-bg-green-200 tw-px-1 tw-py-1 tw-text-center tw-uppercase tw-font-sans tw-leading-loose tw-font-medium tw-text-xs tw-tracking-widest tw-h-auto"
>
  <slot />
</div>
